<ng-container *ngFor="let product of products$ | async; let productIndex = index">
  <div
    #elementRef
    [ngClass]="['d-flex', 'flex-column', productIndex % 2 ? 'even' : 'odd', 'item-' + product.bomItemNo]"
    [class.active]="isActive(product.bomItemNo)"
    [style.margin-top.px]="
      (isTablet$ | async) && adjustMarginTop(productIndex, product.bomItemNo, elementRef)
        ? adjustedMarginTopValue
        : null
    "
    [style.margin-bottom.px]="(isTablet$ | async) && adjustMarginBottom(productIndex, product.bomItemNo, elementRef)"
    *ngIf="hasProduct(product)"
  >
    <div
      [ngClass]="['product', product.code, businessType]"
      [id]="product.bomItemNo"
      (click)="
        toggleSelectedProduct(product.bomItemNo, !isActive(product.bomItemNo)); scrollToFirstProduct(product.bomItemNo)
      "
      [class.active]="isActive(product.bomItemNo)"
      [class.pill-3]="product.bomItemNo.toString().length === 3"
      [class.pill-4]="product.bomItemNo.toString().length === 4"
      [class.pill-5]="product.bomItemNo.toString().length === 5"
      [class.pill-6]="product.bomItemNo.toString().length === 6"
      [class.disabled]="
        (isOutOfStock(product?.code) | async) || !(getDealerPrice(product?.code) | async)?.toString().length
      "
    >
      <div
        class="hotspot-button"
        *ngIf="!(componentService.expandedImageClicked$ | async)"
        [class.invisible]="product.bomItemNo === -1"
      >
        <span
          [class.rounded-circle]="product.bomItemNo.toString().length <= 2"
          [class.pill]="product.bomItemNo.toString().length > 2"
          ><span>{{ product.bomItemNo }}</span>
        </span>
      </div>
      <div class="product-details">
        <span class="sku mr-1">{{ product.code }}</span>
        <ng-container [ngSwitch]="checkStockLevel(product.stock?.stockLevel, product.stock?.stockLevelStatus)">
          <span class="in-stock" *ngSwitchCase="'inStock'">{{ 'product.inStock' | cxTranslate }}</span>
          <span class="no-stock" *ngSwitchCase="'outOfStock'">{{ 'product.noStock' | cxTranslate }}</span>
          <span class="discontinued" *ngSwitchCase="'discontinued'">{{ 'product.discontinued' | cxTranslate }}</span>
        </ng-container>
        <span class="text-truncate name" [title]="product.name">{{ product.name }}</span>
        <app-tooltip-text
          class="bomDescription bom"
          [tooltipContent]="getProductBOM(product.code)"
          [content]="getProductBOM(product.code)"
          placement="bottom"
        ></app-tooltip-text>
      </div>
      <button
        mat-icon-button
        class="expand-more rounded-0"
        [disableRipple]="true"
        [class.rotated]="isActive(product.bomItemNo)"
      >
        <mat-icon *ngIf="!(componentService.expandedImageClicked$ | async)" [attr.test]="'testvariable'"
          >expand_more</mat-icon
        >
      </button>
      <div class="line-break"></div>
    </div>
    <div class="collapsible" [class.d-none]="!isActive(product?.bomItemNo)" [class.show]="isActive(product?.bomItemNo)">
      <ng-container
        [ngTemplateOutlet]="productDetailsMore"
        [ngTemplateOutletContext]="{ product: product }"
      ></ng-container>
    </div>
  </div>
</ng-container>
<ng-template #productDetailsMore let-product="product">
  <div class="product-details-more">
    <div
      class="prices"
      [ngClass]="activeLanguage$ | async"
      [class.gst-labels-on]="(showGstInclusive$ | async) || (showGstExclusive$ | async)"
    >
      <div class="srpPrice">
        <span>{{ 'product.productList.srp' | cxTranslate }}</span>
        <span>{{ getSrpPrice(product?.code) | async }}</span>
        <span class="gst-label" *ngIf="(getSrpPrice(product?.code) | async) && showGstInclusive$ | async">{{
          'gst.inclusive' | cxTranslate
        }}</span>
      </div>
      <ng-container *ngIf="!showSrpOnly">
        <div *ngIf="!basepriceHidden" class="basePrice">
          <span>{{ 'product.productList.basePrice' | cxTranslate }}</span>
          <span>{{ getBasePrice(product?.code) | async }}</span>
          <span class="gst-label" *ngIf="(getBasePrice(product?.code) | async) && showGstExclusive$ | async">{{
            'gst.exclusive' | cxTranslate
          }}</span>
        </div>
        <div class="dealerPrice">
          <span>{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
          <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
            <div class="spinner-shimano ev" *ngIf="this.hasDealerPrice">
              <div></div>
            </div>
            <span class="no-dealer-price no-dealer-price-ev" *ngIf="!this.hasDealerPrice"></span>
          </div>
          <ng-template #dealerPriceReady>
            <span>{{ getDealerPrice(product?.code) | async }}</span>
            <span class="gst-label" *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async">{{
              'gst.exclusive' | cxTranslate
            }}</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
    <div class="actions">
      <div class="pdp">
        <ng-container *ngIf="isDesktop; else pdpNonDesktopTempl">
          <button
            mat-icon-button
            class="assignment rounded-0"
            [disableRipple]="true"
            matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
            [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
            attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
            [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            *ngIf="product && !isPlpPopupEnabled"
          >
            <mat-icon>assignment</mat-icon>
          </button>
          <div *ngIf="isPlpPopupEnabled" [ngTemplateOutlet]="detailsButton"></div>
        </ng-container>

        <ng-template #detailsButton>
          <div class="details-button-pdp">
            <button
              class="details-button secondary-btn btn-block btn"
              type="button"
              matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
              attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            >
              {{ 'buttonTooltip.plp.pdpDetailsButton' | cxTranslate }}
            </button>
          </div>
        </ng-template>

        <ng-template #pdpNonDesktopTempl>
          <button
            mat-icon-button
            class="assignment rounded-0"
            [disableRipple]="true"
            attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
            [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            *ngIf="product && !isPlpPopupEnabled"
          >
            <mat-icon *ngIf="!isPlpPopupEnabled">assignment</mat-icon>
          </button>
          <div *ngIf="isPlpPopupEnabled" [ngTemplateOutlet]="detailsButton"></div>
        </ng-template>
      </div>
      <div class="add-to-cart" [formGroup]="explodedViewFormGroup" *ngIf="product">
        <div class="quantity">
          <fieldset
            [disabled]="
              (isOutOfStock(product?.code) | async) || !(getDealerPrice(product?.code) | async)?.toString().length
            "
          >
            <input
              #quantityInput
              class="form-control"
              type="number"
              min="0"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
              maxlength="3"
              [formControlName]="product?.code"
              (change)="checkInput($event, product?.code)"
            />
          </fieldset>
        </div>
        <ng-container *ngIf="isDesktop; else addToCartNonDesktopTempl">
          <button
            mat-icon-button
            [ngClass]="'sku-' + [product.code]"
            class="add-to-cart-primary rounded-0"
            [disableRipple]="true"
            matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
            [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
            attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
            (click)="backorderCartCheck(product)"
            [disabled]="
              !quantityInput.value ||
              (isOutOfStock(product?.code) | async) ||
              !(getDealerPrice(product?.code) | async)?.toString().length ||
              showSpinner
            "
          >
            <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
          </button>
        </ng-container>
        <ng-template #addToCartNonDesktopTempl>
          <button
            mat-icon-button
            [ngClass]="'sku-' + [product.code]"
            class="add-to-cart-primary rounded-0"
            [disableRipple]="true"
            attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
            (click)="backorderCartCheck(product)"
            [disabled]="
              !quantityInput.value ||
              (isOutOfStock(product?.code) | async) ||
              !(getDealerPrice(product?.code) | async)?.toString().length ||
              showSpinner
            "
          >
            <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
